export const DEFAULT_SOURCE = 'default';
export const sourceMap: { [key: string]: string } = {
    vd: 'viber draft',
    sd: 'sms draft',
};
